import { render, staticRenderFns } from "./RegenerateIcon.vue?vue&type=template&id=5bf4f99b"
import script from "./RegenerateIcon.vue?vue&type=script&lang=js"
export * from "./RegenerateIcon.vue?vue&type=script&lang=js"
import style0 from "./RegenerateIcon.vue?vue&type=style&index=0&id=5bf4f99b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports